import { render, staticRenderFns } from "./roles-list.vue?vue&type=template&id=017865e6&scoped=true"
import script from "./roles-list.vue?vue&type=script&lang=js"
export * from "./roles-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017865e6",
  null
  
)

export default component.exports